export const login = (email, password) =>
  fetch(`${process.env.GATSBY_FUNCTION_PATH}/start-login`, {
    method: 'POST',
    body: JSON.stringify({
      email,
      password,
    }),
  })

export const logout = token =>
  fetch(`${process.env.GATSBY_FUNCTION_PATH}/logout`, {
    method: 'POST',
    headers: {
      token,
    },
  })

export const getTokenFromCode = code =>
  fetch(`${process.env.GATSBY_FUNCTION_PATH}/get-token?code=${code}`, {
    method: 'GET',
  })

export const refreshToken = token =>
  fetch(`${process.env.GATSBY_FUNCTION_PATH}/refresh-box-token`, {
    method: 'POST',
    headers: {
      token,
    },
  })

export const acceptTracking = (token, consent) =>
  fetch(`${process.env.GATSBY_FUNCTION_PATH}/tracking-consent`, {
    method: 'POST',
    headers: {
      token,
    },
    body: JSON.stringify({
      consent,
    }),
  })
